export default "__VITE_ASSET__D2X_dqa3__"